//import utility functions
import { getAppConfigValue } from '../../../utilities/function/configuration'

const loadGoogleRecaptcha = (callback) => {
    const existingScript = document.getElementById('googleRecaptcha');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${getAppConfigValue('google_site_key')}`;
      script.id = 'googleRecaptcha';
      document.body.appendChild(script);
      script.onload = () => { 
        if (callback) callback();
      };
    }
    if (existingScript && callback) callback();
}
export default loadGoogleRecaptcha;